import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CartShopifyService } from './cart-shopify.service';
@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {
  private cartKey = 'ss_shopping_cart';
  private cartItems: any[] = [];

  private cartItemsSubject = new BehaviorSubject<any[]>([]);
  cartItems$ = this.cartItemsSubject.asObservable();

  private cartCountSubject = new BehaviorSubject<number>(0);
  cartCount$ = this.cartCountSubject.asObservable();

  private platform: string;

  constructor(
    private shopifyCartService: CartShopifyService
  ) {
    this.platform = localStorage.getItem("ss_cart_platform") || "other";
    this.loadCart()
  }

  loadCart() {
    if (this.platform === "shopify") {
      if (this.isRunningInsideShopify()) {
        this.loadCartFromShopify();
        return;
      }
      console.warn("⚠️ Tentativa de carregar carrinho da Shopify fora do ambiente Shopify ignorada.");
    }

    const storedCart = localStorage.getItem(this.cartKey);

    this.cartItems = storedCart ? JSON.parse(storedCart) : [];
    const newCartCount = this.cartItems.reduce((total, item) => total + item.quantity, 0);
    this.cartItemsSubject.next([...this.cartItems]);
    this.cartCountSubject.next(newCartCount);
    this.emitCartUpdate();
  }
  private isRunningInsideShopify(): boolean {
    const w = window as any;
    const hostname = String(window.location?.hostname || '');

    // Evita falso-positivo: alguns ambientes podem ter `window.Shopify` definido sem ser um storefront real.
    const hasRoutesRoot =
      typeof w?.Shopify?.routes?.root === 'string' &&
      String(w.Shopify.routes.root).trim().length > 0;

    const isMyShopifyHost = hostname.endsWith('.myshopify.com');

    return hasRoutesRoot || isMyShopifyHost;
  }
  loadCartFromShopify() {
    const storedCart = localStorage.getItem(this.cartKey);
    const fallbackItems = storedCart ? JSON.parse(storedCart) : this.cartItems;
    this.shopifyCartService.getCartDetails().subscribe({
      next: (response) => {
        console.log('Shopify cart.js response:', response);
        this.syncShopifyCart(response.items, fallbackItems);
      },
      error: (error) => {
        console.error("❌ Erro ao buscar carrinho da Shopify:", error);
      }
    });
  }

  syncShopifyCart(items: any[] = [], fallbackItems: any[] = []) {
    
    console.log('syncCartShopify')
    console.log(fallbackItems)

    const baseFallback = (fallbackItems && fallbackItems.length) ? fallbackItems : this.cartItems;
    const fallbackMap = this.buildFallbackMap(baseFallback);

    const normalized = this.normalizeShopifyItems(items, fallbackMap);
    this.cartItems = normalized;
    this.persistLocalCartSnapshot(normalized);

    const totalItems = normalized.reduce((total, item) => total + item.quantity, 0);
    this.cartItemsSubject.next([...normalized]);
    this.cartCountSubject.next(totalItems);
    this.emitCartUpdate();
  }

  private buildFallbackMap(fallbackItems: any[]): Map<string, any> {
    const map = new Map<string, any>();
    (fallbackItems || []).forEach((item: any) => {
      const variantKey = this.normalizeVariantId(item?.variant_id ?? item?.id ?? item?.sku);
      if (variantKey) {
        map.set(variantKey, item);
      }
    });
    return map;
  }

  private normalizeVariantId(raw: any): string {
    if (raw == null) return '';
    const str = String(raw);
    const match = str.match(/(\d+)$/);
    return match ? match[1] : str;
  }

  private normalizeShopifyItems(items: any[], fallbackMap?: Map<string, any>): any[] {
    return (items || []).map((item: any) => {
	      const baseTitle = item.product_title || item.title || 'Produto';
	      const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
	        ? String(item.variant_title)
	        : '';
      const priceSource = typeof item.final_price === 'number'
        ? item.final_price
        : item.price;
      const variantKey = this.normalizeVariantId(item.id ?? item.variant_id ?? item.variant?.id);
      const fallback = fallbackMap?.get(variantKey);
      const inventoryQuantity = Number(
        fallback?.inventory_quantity ??
        fallback?.stock ??
        item.quantity_rule?.max ??
        item.variant?.inventory_quantity ??
        item.inventory_quantity ??
        0
      );
      const categories = this.normalizeCartCategories(
        fallback?.categories ?? fallback?.category
      );
      console.log('Normalizing Shopify item', {
        rawItem: item,
        fallback,
        resolvedInventory: inventoryQuantity
      });

	      return {
	        id: item.product_id ?? item.id,
	        variant_id: item.id,
	        key: item.key ?? fallback?.key ?? null,
	        name: String(baseTitle).trim(),
	        variant: variantLabel || undefined,
	        price: typeof priceSource === 'number' ? priceSource / 100 : Number(priceSource),
	        image: item.image || item.featured_image?.url || '',
        quantity: item.quantity,
        inventory_quantity: inventoryQuantity,
        stock: inventoryQuantity,
        tracked: fallback?.tracked ?? item.tracked ?? item.requires_shipping ?? false,
        categories,
        category: categories.length ? categories[0] : ''
      };
    });
  }

  private saveCart() {
    console.log('persistido')
    console.log(this.cartItems)
    this.persistLocalCartSnapshot(this.cartItems);
    this.updateCartState();
  }

  private persistLocalCartSnapshot(items: any[]) {
    console.log('persistLocalCartSnapshot')
    console.log(JSON.stringify(items))
    localStorage.setItem(this.cartKey, JSON.stringify(items));
  }

  addToCart(product: any, quantity: number = 1, mainImage: string): boolean {
    try {
      const existingItem = this.cartItems.find(item => item.id === product.id);
      const normalizedCategories = this.normalizeCartCategories(product?.categories ?? product?.category);

      console.log('addToCart');
      console.log(this.cartItems);

      const productImage = mainImage || product.thumbnail || (product.images?.length ? product.images[0] : 'assets/images/default-product.png');

      if (existingItem) {
        existingItem.quantity += quantity;
	        if ((!existingItem.categories || !existingItem.categories.length) && normalizedCategories.length) {
	          existingItem.categories = normalizedCategories;
	          existingItem.category = normalizedCategories[0];
	        }
	        if (!existingItem.variant && product?.variant) {
	          existingItem.variant = product.variant;
	        }
	      } else {
	        this.cartItems.push({
          id: product.id,                 // (pra você hoje id = variantId no nuvemshop)
          variant_id: product.variant_id,
          product_id: product.product_id, // ✅ ADICIONA ISSO AQUI
        
	          name: product.title || product.name,
	          variant: product.variant || undefined,
	          price: product.price,
          image: productImage,
          stock: product.inventory_quantity || product.stock || 0,
          tracked: product.tracked ?? false,
          quantity: quantity,
          categories: normalizedCategories,
          category: normalizedCategories[0] ?? ''
        });
      }
      this.saveCart();




      // ✅ Atualiza os observables corretamente ANTES de emitir o evento
      const updatedCart = [...this.cartItems];
      const newCartCount = updatedCart.reduce((total, item) => total + item.quantity, 0);

      this.cartItemsSubject.next(updatedCart);
      this.cartCountSubject.next(newCartCount);

      console.log("📦 Cart atualizado antes do evento:", updatedCart);
      console.log("🔄 Nova contagem de itens antes do evento:", newCartCount);

      // 🔥 Aguarda um curto delay para garantir que o estado seja propagado antes do evento
      setTimeout(() => {
        this.emitCartUpdate();
      }, 200);


      return true; // ✅ Retorna sucesso
    } catch (error) {
      console.error("❌ Erro ao adicionar ao carrinho:", error);
      return false; // ❌ Retorna erro
    }
  }

  getCartItems(): any[] {
    return [...this.cartItems]; // Retorna uma cópia para evitar mutações diretas
  }

  removeFromCart(productId: number): boolean {
    const isShopifyStorefront = this.platform === "shopify" && this.isRunningInsideShopify();

    if (isShopifyStorefront) {
      const item = this.cartItems.find(i =>
        String(i?.key ?? '') === String(productId) ||
        String(i?.id ?? '') === String(productId) ||
        String(i?.variant_id ?? '') === String(productId)
      );

      const itemKey = item?.key ? String(item.key) : String(productId);
      if (!item?.key) {
        console.warn("⚠️ removeFromCart: key não encontrada no item, usando productId como fallback.", {
          productId,
          item
        });
      }

      this.shopifyCartService.removeFromCart(itemKey).subscribe({
        next: () => {
          this.shopifyCartService.getCartDetails().subscribe({
            next: (cartResponse) => this.syncShopifyCart(cartResponse.items),
            error: (error) => console.error("❌ Erro ao carregar carrinho atualizado:", error)
          });
        },
        error: (error) => console.error("❌ Erro ao remover item da Shopify:", error)
      });
      return true;
    }

    // Fora de storefront Shopify (ou outras plataformas) => fluxo local
    const itemIndex = this.cartItems.findIndex(item =>
      String(item?.id ?? '') === String(productId) ||
      String(item?.variant_id ?? '') === String(productId)
    );

    if (itemIndex !== -1) {
      this.cartItems.splice(itemIndex, 1);
      this.saveCart();
      this.updateCartState();
      return true;
    }

    return false;
  }

  clearCart() {
    this.cartItems = [];
    this.saveCart();
    this.updateCartState();
  }

  updateCartItemQuantity(productId: number, newQuantity: number): boolean {
    const isShopifyStorefront = this.platform === "shopify" && this.isRunningInsideShopify();

    if (isShopifyStorefront) {
      const item = this.cartItems.find(i =>
        String(i?.key ?? '') === String(productId) ||
        String(i?.id ?? '') === String(productId) ||
        String(i?.variant_id ?? '') === String(productId)
      );

      const itemKey = item?.key ? String(item.key) : String(productId);
      if (!item?.key) {
        console.warn("⚠️ updateCartItemQuantity: key não encontrada no item, usando productId como fallback.", {
          productId,
          item
        });
      }

      this.shopifyCartService.updateCartItemQuantity(itemKey, newQuantity).subscribe({
        next: (response) => {
          console.log("✅ Quantidade atualizada no carrinho da Shopify:", response);

          // 🔥 Após a atualização, recarrega o carrinho corretamente
          this.shopifyCartService.getCartDetails().subscribe({
            next: (cartResponse) => {
              console.log("🔄 Carrinho atualizado após modificação:", cartResponse.items);
              this.syncShopifyCart(cartResponse.items);
            },
            error: (error) => console.error("❌ Erro ao carregar carrinho atualizado:", error)
          });

        },
        error: (error) => console.error("❌ Erro ao atualizar quantidade na Shopify:", error)
      });

      return true;
    }

    const item = this.cartItems.find(item =>
      String(item?.id ?? '') === String(productId) ||
      String(item?.variant_id ?? '') === String(productId)
    );

    if (item) {
      item.quantity = newQuantity;
      this.saveCart();
      this.updateCartState();
      return true;
    }

    return false;
  }

  // ✅ Método público para forçar atualização do estado do carrinho
  refreshCartState() {
    this.loadCart();
  }

  private updateCartState() {
    this.cartItemsSubject.next([...this.cartItems]);
    const newCartCount = this.cartItems.reduce((total, item) => total + (item.quantity ?? 0), 0);
    this.cartCountSubject.next(newCartCount);
    this.emitCartUpdate();
  }


  private cartUpdatedSubject = new BehaviorSubject<boolean>(false);
  cartUpdated$ = this.cartUpdatedSubject.asObservable();

  // 🔥 Método para forçar a atualização
  triggerCartUpdate() {
    this.cartUpdatedSubject.next(true);
  }

  updateCartCount(newCount: number) {
    this.cartCountSubject.next(newCount);
    this.emitCartUpdate();
  }



  private emitCartUpdate() {
    setTimeout(() => {
      const count = this.cartCountSubject.getValue();

      this.cartUpdatedSubject.next(true);

      const event = new CustomEvent('cartUpdated', {
        detail: { count }
      });

      window.dispatchEvent(event);
    }, 100);
  }

  private normalizeCartCategories(source: any): string[] {
    if (!source) {
      return [];
    }
    const list = Array.isArray(source) ? source : [source];
    return list
      .map(entry => {
        if (!entry) return null;
        if (typeof entry === 'string') return entry.trim();
        if (typeof entry === 'object') {
          const name = entry.title ?? entry.name;
          return name ? String(name).trim() : null;
        }
        return null;
      })
      .filter((value): value is string => !!value && value.length > 0);
  }
}
